import { VocabType } from '@doltech/utils/lib/enum/VocabTypeEnum';
import { nanoid } from 'nanoid';
import { Editor, Node, Path, Transforms } from 'slate';

import { createNode } from '../../../../../slatePlugins/common/utils/createNode';
import { ComposedEditor } from '../../../types';
import { MediaType } from '../../media-constant';
// import { getTableById } from '../../table/queries/getTableById';
import { createTable } from '../../table/utils';
import { DEFI, EX, IMG, LEFT, PRONOUNCE, RIGHT, RIGHT1, WORD } from '../../vocab-card/type';
import { canAddTable } from '../queries/canAddTable';

/**
 * Add a table into editor if only the cursor not in any table
 *  (nested table is not supported yet)
 *
 *
 * @export
 * @param {ComposedEditor} editor
 */
export function addTable(editor: ComposedEditor) {
  if (canAddTable(editor)) {
    const table = createTable({ cellsWidth: [213, 213, 213] }, { rows: 3 });
    Transforms.insertNodes(editor, [table, createNode('p', '')]);
    // const [, path] = getTableById(editor, table.id);
    // const firstCellPoint = { path: path.concat(0, 0), offset: 0 };
    // Transforms.setSelection(editor, { anchor: firstCellPoint, focus: firstCellPoint });
  }
}

export function createMediaNode(type, options = {}) {
  return {
    type,
    isVoid: true,
    id: nanoid(),
    ...options,
    children: [
      {
        text: '',
      },
    ],
  };
}

export function addMedia(editor: Editor, type) {
  Transforms.insertNodes(editor, createMediaNode(type));
}

function generateLeft(id, world = '', pronouce = '') {
  return {
    id,
    type: LEFT,
    children: [generateWord(world, id), generatePronoun(pronouce, id)],
  } as Node;
}

function generateRight(define = '', example = '', id = '') {
  return {
    id,
    type: RIGHT,
    children: [generateR1(define, example, id), genereateIMG(id, define.length > 0)],
  } as Node;
}

function generateR1(define = '', example = '', id = '') {
  return {
    id,
    type: RIGHT1,
    children: [generateDefi(define, id), generateEx(example, id)],
  } as Node;
}

function generateDefi(text = '', id = '') {
  return {
    id,
    type: DEFI,
    isPreview: text.length > 0,
    children: [{ text }],
  } as Node;
}

function generateEx(text = '', id = '') {
  return {
    id,
    type: EX,
    isPreview: text.length > 0,
    children: [{ text }],
  } as Node;
}

function genereateIMG(id, isPreview = false) {
  return {
    id,
    type: IMG,
    isPreview,
    children: [{ text: '' }],
  } as Node;
}

function generateWord(text = '', id = '') {
  return {
    id,
    isPreview: text.length > 0,
    type: WORD,
    children: [{ text }],
  } as Node;
}

function generatePronoun(text = '', id = '') {
  return {
    id,
    isPreview: text.length > 0,
    type: PRONOUNCE,
    children: [{ text: text.length > 0 ? `/${text}/` : text }],
  } as Node;
}

export function addVocabCard(editor: Editor, type) {
  const id = nanoid();
  const { selection } = editor;
  const node = {
    type,
    id,
    pType: '',
    url: '',
    children: [generateLeft(id), generateRight('', '', id)],
  };

  if (selection) {
    const nodeEntries = Array.from(
      Editor.nodes(editor, {
        at: editor?.selection,
      })
    );

    const index = nodeEntries.findIndex(([nodeE]: any) => nodeE.type === MediaType.VOCAB_CARD);
    if (index > -1) {
      const endOfDoc = Editor.end(editor, []);
      const [, endNodePath] = Editor.node(editor, endOfDoc, { depth: 1 }) as any;
      Transforms.insertNodes(editor, node, {
        at: Path.next(endNodePath),
      });
      return;
    }
  }

  Transforms.insertNodes(editor, node);
}

export function convertDataToVocabNode(obj) {
  const { type, value: word, pronounce, example, image, meaning } = obj;
  const id = nanoid();
  let vType;
  switch (type) {
    case VocabType.NOUN:
      vType = 'noun';
      break;
    case VocabType.VERB:
      vType = 'verb';
      break;
    case VocabType.ADV:
      vType = 'adv';
      break;
    case VocabType.ADJ:
      vType = 'adj';
      break;
    case VocabType.PRONOUN:
      vType = 'pronoun';
      break;
  }
  return {
    type: MediaType.VOCAB_CARD,
    id,
    isPreview: true,
    pType: vType,
    url: image,
    children: [generateLeft(id, word, pronounce), generateRight(meaning, example, id)],
  };
}
